<script>
    import Layout from "../../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Forms from "../../../../mixins/Forms";
    import axios from 'axios';

    /**
     * Twilio phone number create component
     */
    export default {
        page: {
            title: "Create New Ticket Note Template",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        mixins: [Forms],
        data() {
            return {
                title: "Add New Twilio Phone Number",
                items: [
                    {
                        text: "Settings",
                        href: "#"
                    },
                    {
                        text: "Add Twilio Phone Number",
                        active: true
                    }
                ],
                form: {
                    name: '',
                    phone_number: '',
                    country_code: ''
                },
                serverErrors: [],
                isSaving: false,
                editor: null
            };
        },
        methods: {
            attemptSave() {
                this.save();
            },

            save() {
                let vm = this;

                vm.isSaving = true;
                axios.post(API_BASE + '/twilio-phone-numbers', {
                    name: vm.form.name,
                    phone_number: vm.form.phone_number,
                    country_code: vm.form.country_code
                }).then(r => {
                    vm.isSaving = false;
                    this.$notify.success({
                        title: 'Success!',
                        message: 'Phone number created successfully'
                    });
                    vm.$router.push('/settings/twilio-phone-numbers/');
                }).catch(e => {
                    console.log(e);
                    vm.isSaving = false;
                    vm.setErrors(e);
                });
            }
        }
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <errors :error-list="serverErrors"></errors>
        <loading-screen :is-loading="isSaving"></loading-screen>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <!--            <h4 class="card-title mb-4">Ticket Details</h4>-->
                        <form>
                            <div class="form-group row mb-4">
                                <label for="name" class="col-form-label col-lg-2">Name</label>
                                <div class="col-lg-10">
                                    <input
                                            id="name"
                                            name="name"
                                            type="text"
                                            class="form-control"
                                            v-model="form.name"
                                            autofocus
                                    />
                                </div>
                            </div>
                            <div class="form-group row mb-4">
                                <label for="countryCode" class="col-form-label col-lg-2">Country Code</label>
                                <div class="col-lg-10">
                                    <input
                                            id="countryCode"
                                            name="name"
                                            type="text"
                                            class="form-control"
                                            v-model="form.country_code"
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="phone_number" class="col-form-label col-lg-2">Phone Number</label>
                                <div class="col-lg-10">
                                    <input
                                            id="phone_number"
                                            name="phone_number"
                                            type="text"
                                            class="form-control"
                                            v-model="form.phone_number"
                                    />
                                </div>
                            </div>
                        </form>
                        <div class="row justify-content-end">
                            <div class="col-lg-10">
                                <button type="submit" class="btn btn-itg-dark" @click.prevent="attemptSave">Add Phone Number</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>

<style scoped>
</style>
